// Vue Router gives each browser-history entry a key. Keep its predecessor on
// the entry itself so replace, Back, Forward, and reload retain the same answer.
export function trackBackRoutes(router) {
  let currentKey = window.history.state?.key
  return router.afterEach((to, from) => {
    const state = window.history.state || {}
    if (!Object.prototype.hasOwnProperty.call(state, 'previousRoute')) {
      const previousRoute = state.key !== currentKey && from.name != null ? from.fullPath : null
      window.history.replaceState({ ...state, previousRoute }, '')
    }
    currentKey = state.key
  })
}

export function backToAncestor(router, parentRoute) {
  const previous = window.history.state?.previousRoute
  const parentPath = router.resolve(parentRoute).route.path.replace(/\/$/, '')
  const previousPath = previous == null ? null : router.resolve(previous).route.path.replace(/\/$/, '')
  if (previousPath != null && (parentPath === previousPath || parentPath.startsWith(`${previousPath}/`))) {
    router.back()
  } else {
    router.push(parentRoute)
  }
}

export default {
  methods: {
    goBack() {
      backToAncestor(this.$router, this.backFallbackRoute)
    },
  },
}
